import {
  GET_RETURN_VOUCHERS,
  GET_RETURN_VOUCHERS_SUCCESS,
  GET_RETURN_VOUCHERS_FAILURE,
  GET_RETURN_VOUCHER,
  GET_RETURN_VOUCHER_SUCCESS,
  GET_RETURN_VOUCHER_FAILURE,
  OPEN_RETURN_VOUCHER_DRAWER,
  CLOSE_RETURN_VOUCHER_DRAWER,
  CANCEL_RETURN_VOUCHER_SUCCESS,
  UPDATE_RETURN_VOUCHER_SUCCESS
} from './vouchersActions';

const initialState = {
  returnVouchers: [],
  currentReturnVoucher: {},
  watchCurrentReturnVoucher: false,
  totalResults: 0,
  loadingVouchers: true,
  loadingCurrentReturnVoucher: true,
  openDrawer: false
};

const initReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_RETURN_VOUCHER_DRAWER:
      return {
        ...state,
        openDrawer: true
      };
    case CLOSE_RETURN_VOUCHER_DRAWER:
      return {
        ...state,
        openDrawer: false
      };
    case GET_RETURN_VOUCHERS:
      return {
        ...state,
        loadingVouchers: true
      };
    case GET_RETURN_VOUCHERS_SUCCESS:
      return {
        ...state,
        returnVouchers: action.payload.returnVouchers,
        totalResults: action.payload.totalResults,
        loadingVouchers: false
      };
    case GET_RETURN_VOUCHERS_FAILURE:
      return {
        ...state,
        loadingVouchers: false
      };
    case GET_RETURN_VOUCHER:
      return {
        ...state,
        loadingCurrentReturnVoucher: true,
        openDrawer: true
      };
    case GET_RETURN_VOUCHER_SUCCESS:
      return {
        ...state,
        currentReturnVoucher: action.payload.returnVoucher,
        loadingCurrentReturnVoucher: false
      };
    case GET_RETURN_VOUCHER_FAILURE:
      return {
        ...state,
        loadingCurrentReturnVoucher: false
      };
    case CANCEL_RETURN_VOUCHER_SUCCESS:
      return {
        ...state,
        watchCurrentReturnVoucher: !state.watchCurrentReturnVoucher,
        currentReturnVoucher: {
          ...state.currentReturnVoucher,
          isCancellableBySender: false
        }
      };
    case UPDATE_RETURN_VOUCHER_SUCCESS:
      return {
        ...state,
        watchCurrentReturnVoucher: !state.watchCurrentReturnVoucher
      };
    default:
      return state;
  }
};

export default initReducer;
